/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import Survey from './components/Typebot.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/omnibot'),
    name: 'typebot',
    roles: ['administrator', 'agent'],
    component: Survey,
  },
];
